import { LogManager } from './LogManager';

const logManager = new LogManager('GlobalLoader');

let activeLoadersMap: { [key: string]: number }  = {};
let globalLoaderIsVisible: boolean = false;
let globalLoaderIsDisabled: boolean = false;

const getGlobalLoader = (): any | null => {
    return document.getElementById('global-loader');
};

const getVisibleLoadersCount = (): number => {
    const keys = Object.keys(activeLoadersMap);
    let count = 0;
    for (const key of keys) {
        const value = activeLoadersMap[key];
        if (value) {
            count++;
        }
    }
    return count;
};

let loaderDurationTimeout: NodeJS.Timer | null = null;
const startTrackingLoaderDuration = () => {
    if (!loaderDurationTimeout) {
        loaderDurationTimeout = setTimeout(
            () => {
                logManager.error('Global loader seems to be stuck');
                // location.reload();
            },
            10_000
        );
    }
};

const stopTrackingLoaderDuration = () => {
    if (loaderDurationTimeout) {
        clearTimeout(loaderDurationTimeout);
        loaderDurationTimeout = null;
    }
};

let lastLoaderCommandIsVisible: boolean | null = null;

const makeGlobalLoaderVisible = (): void => {
    const globalLoader = getGlobalLoader();
    if (globalLoader) {
        globalLoader.style.display = 'flex';
        globalLoaderIsVisible = true;
        startTrackingLoaderDuration();
    } else {
        lastLoaderCommandIsVisible = true;
    }
};

const makeGlobalLoaderHidden = (): void => {
    const globalLoader = getGlobalLoader();
    if (globalLoader) {
        globalLoader.style.display = 'none';
        globalLoaderIsVisible = false;
        stopTrackingLoaderDuration();
    } else {
        lastLoaderCommandIsVisible = false;
    }
};

document.addEventListener(
    'DOMContentLoaded',
    () => {
        if (lastLoaderCommandIsVisible == null) { return; }

        if (lastLoaderCommandIsVisible) {
            makeGlobalLoaderVisible();
        } else {
            makeGlobalLoaderHidden();
        }
    }
);

export const setGlobalLoaderDisabled = (isDisabled: boolean) => {
    if (isDisabled) {
        makeGlobalLoaderHidden();
    } else {
        if (getVisibleLoadersCount()) {
            makeGlobalLoaderVisible();
        }
    }
    globalLoaderIsDisabled = isDisabled;
};

export const getGlobalLoaderDisabled = (): boolean => {
    return globalLoaderIsDisabled;
};

export const showGlobalLoader = (loaderName: string): void => {
    if (!activeLoadersMap[loaderName]) {
        activeLoadersMap[loaderName] = 0;
    }
    activeLoadersMap[loaderName]++;

    if (globalLoaderIsDisabled) { return; }

    makeGlobalLoaderVisible();
};

export function hideGlobalLoader(loaderName: string): void;
export function hideGlobalLoader(): void;
export function hideGlobalLoader(loaderName?: string): void {
    if (!loaderName) {
        makeGlobalLoaderHidden();
        activeLoadersMap = {};
        return;
    }

    if (!activeLoadersMap[loaderName]) { return; }

    activeLoadersMap[loaderName]--;

    if (!globalLoaderIsVisible) { return; }
    if (getVisibleLoadersCount() > 0) { return; }

    makeGlobalLoaderHidden();
}



// WEBPACK FOOTER //
// ./src/webportal/utils/GlobalLoader.ts